// 客服工单字段枚举
export const CustomerFieldsEnum = {
  UUID: '24146301777305',
  SITE: '49809623417753',
  ORDER_NO: '24009810322457',
  PRODUCT_URL: '24009816467353',
  PIN: '24146246374681',
};